export default __webpack_public_path__ + "static/media/biocentric_health_theory.473292b1.png";